export default __webpack_public_path__ + "static/soc-2-compliance-saas-provider-6242967e36373da18d41ecba4c0bd69f.png";